<template>
  <div>

    <CheckId :userData="userData"/>

  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import CheckId from "./CheckId.vue";
// import PasswordForm from "@/_zplabZPT/signUp/comp/userForm/comp/PasswordForm.vue";
const modelService = require("@/utils/dataModel.js");

export default {
  components: {
    CheckId,
    // PasswordForm,
  },
  data() {
    return {
      step: "sms",
      // step: "changePassword",
      userData: modelService.userModel(),
      // 변경할 비번 데이터
      // reqData: {
      //   endpoint: "checkIdPw",
      //   loginId: "", // sms인증한 사용자 cell
      //   code: "", // sms 전송받은 문자코드
      //   password: "", // 변경된 비번
      // },
    };
  },
  methods: {
    completeCertify(reqData) {
      // this.step = "changePassword";
      this.reqData.userCell = reqData.userCell;
      this.reqData.code = reqData.code;
      setTimeout(() => {
        this.$refs.refPasswordForm.$refs.refPassword.focus();
      }, 500);
    },
    changePassword() {
      console.log("", this.userData);
      this.reqData.password = this.userData.password;
      this.saveDataPreLoginQuery(this.reqData).then((res) => {
        if (res === undefined) return;
        this.$helper.showTostMessage(
          "",
          "회원로그인 비밀번호가 변경되었습니다.",
          "success"
        );
        this.$router.push("/login");
      });
    },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
};
</script>
<style lang="scss">
.v-list-item__title {
  font-size: 14px;
  font-weight: bold;
  padding: 0 15px 5px;
  color: $primary-text-color;

  .asterisk {
    color: $text-red;
  }
}
</style>
